"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var enquiryFormErrorTransformer = {
    from: function (error, intl) {
        var _a, _b, _c;
        // Transforms a string of format 'field.nestedField: errorMessages'
        var validationErrors = {};
        var fullPath = (_a = error.split(':')[0], (_a !== null && _a !== void 0 ? _a : null));
        var errorMessage = (_b = error.split(':')[1].trim(), (_b !== null && _b !== void 0 ? _b : ''));
        if ((_c = intl.messages) === null || _c === void 0 ? void 0 : _c[errorMessage]) {
            errorMessage = intl.formatMessage({ id: errorMessage });
        }
        var pathArray = fullPath.includes('.') ? fullPath.split('.') : [fullPath];
        var lastNestedField = pathArray[pathArray.length - 1];
        if (!fullPath || !errorMessage) {
            throw new Error('The validation error is not formatted correctly!');
        }
        pathArray.reduce(function (field, nestedField) {
            return (field[nestedField] = nestedField === lastNestedField ? { __errors: [errorMessage] } : {});
        }, validationErrors);
        return validationErrors;
    },
};
exports.default = enquiryFormErrorTransformer;
